export const components = {
  emptyState: {
    primaryTitle: 'Hoppla!',
    primaryText: 'Hier gibt es noch nichts zu sehen…',
    secondaryTitle: 'Nichts zu anzeigen',
    secondaryText: 'Leider gibt es keine Elemente zur Anzeige basierend auf den angewendeten Filtern…'
  },
  filters: {
    all: 'Alle',
    search: 'Suche',
    priceRange: 'Preisspanne {currency}',
    minValue: 'Der Mindestwert beträgt {val}!',
    maxValue: 'Der Maximalwert beträgt {val}!',
    reset: 'Zurücksetzen',
    apply: 'Anwenden'
  },
  comments: {
    reply: 'Antworten',
    loadMore: 'Mehr laden',
    edited: 'Bearbeitet',
    noComments: 'Es gibt noch keine Kommentare',
    leaveFirstComment: 'Du kannst den ersten hinterlassen'
  },
  curtain: {
    close: 'Schließen'
  },
  photoPreview: {
    close: 'Schließen'
  },
  photoCropper: {
    back: 'Zurück',
    save: 'Speichern'
  },
  rightSidebar: {
    in: 'in'
  },
  pushPrompt: {
    title: '“{appName}” möchte Ihnen Benachrichtigungen senden',
    description:
      'Benachrichtigungen können Warnungen, Geräusche und Symbolabzeichen enthalten. Diese können in den Einstellungen konfiguriert werden.',
    later: 'Später fragen',
    neverLater: 'Nie wieder fragen',
    allow: 'Erlauben'
  },
  inAppPush: {
    attachment: 'Anhang'
  },
  installPrompt: {
    android: {
      install: 'Installieren',
      description: 'Für ein nahtloses Erlebnis müssen Sie keinen Browser verwenden. Installieren Sie es einfach als App.',
      press: 'Drücken Sie',
      andSelect: 'und wählen Sie',
      orSimply: 'oder einfach',
      description2: 'klicken Sie auf die Schaltfläche Installieren unten',
      notNow: 'Jetzt nicht'
    },
    ios: {
      justTap: 'Tippen Sie auf die',
      buttonInBrowser: '„Mehr"-Schaltfläche in Ihrem Browser und wählen Sie „Teilen"',
      addToHomeScreen: 'Scrollen Sie nach unten und tippen Sie auf „Zum Home-Bildschirm", dann klicken Sie auf „Hinzufügen"',
      appWillBeInstalled: 'Die App wird Ihrem Startbildschirm hinzugefügt'
    },
    installApp: 'App installieren',
    useWeb: 'Web-Version verwenden'
  },
  footer: {
    more: 'Menü'
  },
  menu: {
    installApp: 'App installieren',
    menu: 'Menü',
    close: 'Schließen'
  },
  404: {
    whoops: 'Hoppla!',
    description:
      'Es scheint, als ob die Seite nicht existiert oder Sie keinen Zugriff darauf haben. Bitte kontaktieren Sie den App-Besitzer für weitere Informationen.',
    ok: 'OK'
  },
  relatedUsers: {
    seeall: 'Alle anzeigen'
  },
  networkingCurtain: {
    'newOneOnOne': 'Neues 1:1',
    'details': 'Details',
    'coverMessage': 'Decknachricht',
    'location': 'Standort',
    'duration': 'Dauer',
    '15min': '15 Min',
    '30min': '30 Min',
    '45min': '45 Min',
    '60min': '60 Min',
    'timeSlot': 'Zeitraum',
    'sendInvitation': 'Einladung senden',
    'success': 'Erfolg',
    'invitationSent':
      'Sie haben die Einladung zu einem 1:1-Meeting erfolgreich gesendet. Möchten Sie auf dieser Seite bleiben oder zu allen geplanten 1:1-Meetings navigieren?',
    'seeAll': 'Alle 1:1-Meetings ansehen',
    'stayHere': 'Hier bleiben'
  },
  networking: {
    level: {
      1: 'Noch nicht bereit zum Netzwerken. Keine signifikante Aktivität oder Beteiligung.',
      2: 'Selten aktiv oder fehlen wichtige Profilinformationen, die es anderen schwer machen, sich zu verbinden.',
      3: 'Profil vollständig mit Foto und online, vollständig bereit, mit dem Netzwerken zu beginnen.',
      4: 'Baut Momentum auf - hat in den letzten 6 Stunden mindestens eine Verbindung initiiert.',
      5: 'Ein Networking-Meister - reagiert aktiv auf Anfragen und engagiert sich mit anderen in den letzten 6 Stunden.'
    }
  },
  time: {
    days: 'T',
    hours: 'h',
    minutes: 'm',
    seconds: 's',
    startsIn: 'in',
    Today: 'Heute',
    today: 'heute',
    Tomorrow: 'Morgen',
    tomorrow: 'morgen',
    Yesterday: 'Gestern',
    yesterday: 'gestern',
    startingNow: 'beginnt jetzt'
  },
  daysMonths: {
    months: "['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember']",
    monthsShort: "['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']",
    weekdays: "['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']",
    weekdaysShort: "['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa']",
    weekdaysMin: "['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa']"
  },
  badges: {
    legend: 'Legendary Networker',
    push: 'Online and Trusted',
    leader: 'Leaderboard Champ',
    meetmaster: '1:1 Meeting Master',
    connector: '3-Time Connector',
    legend_description:
      'Erreiche mindestens einmal das Legend-Level, indem du aktiv netzwerkst und sinnvolle Verbindungen herstellst.',
    push_description: 'Aktiviere Push-Benachrichtigungen, um immer reaktionsfähig zu bleiben und keine Gelegenheit zu verpassen.',
    leader_description: 'Schaffe es mindestens einmal in die Top 10 % auf der Bestenliste.',
    meetmaster_description: 'Starte oder antworte auf mindestens eine 1:1 Meeting-Anfrage in der App.',
    connector_description: 'Stelle während der Komponenten mindestens drei Verbindungen über die App her.'
  }
}
